import type { JSX } from 'react';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import Lockup from '@/brand/Lockup';

export function Footer(): JSX.Element {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="border-ink bg-ink text-paper border-t py-20">
      <div className="mx-auto max-w-[1240px] px-6">
        <div className="mb-16 grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <Lockup size={28} dark />
            <p className="text-paper/80 m-0 mt-6 max-w-[280px] font-mono text-[12px] leading-[1.55]">
              {t('footer.tagline')}
            </p>
            <div className="text-paper/50 mt-6 font-mono text-[11px] tracking-[0.18em] uppercase">
              {t('footer.office')}
            </div>
          </div>

          <div>
            <h5 className="text-paper/50 m-0 mb-4 font-mono text-[11px] tracking-[0.18em] uppercase">
              {t('footer.col.product')}
            </h5>
            <ul className="m-0 flex list-none flex-col gap-2 p-0">
              <li>
                <a href="#markets" className="text-paper hover:text-orange transition-colors">
                  {t('footer.links.markets')}
                </a>
              </li>
              <li>
                <a href="#orderbook" className="text-paper hover:text-orange transition-colors">
                  {t('footer.links.orderBook')}
                </a>
              </li>
              <li>
                <a href="#orderbook" className="text-paper hover:text-orange transition-colors">
                  {t('footer.links.exit')}
                </a>
              </li>
              <li>
                <span className="text-paper/70 cursor-default">{t('footer.links.api')}</span>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="text-paper/50 m-0 mb-4 font-mono text-[11px] tracking-[0.18em] uppercase">
              {t('footer.col.company')}
            </h5>
            <ul className="m-0 flex list-none flex-col gap-2 p-0">
              <li>
                <a href="#about" className="text-paper hover:text-orange transition-colors">
                  {t('footer.links.about')}
                </a>
              </li>
              <li>
                <span className="text-paper/70 cursor-default">{t('footer.links.press')}</span>
              </li>
              <li>
                <span className="text-paper/70 cursor-default">{t('footer.links.careers')}</span>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="text-paper/50 m-0 mb-4 font-mono text-[11px] tracking-[0.18em] uppercase">
              {t('footer.col.legal')}
            </h5>
            <ul className="m-0 flex list-none flex-col gap-2 p-0">
              <li>
                <Link to="/terms" className="text-paper hover:text-orange transition-colors">
                  {t('footer.links.terms')}
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-paper hover:text-orange transition-colors">
                  {t('footer.links.privacy')}
                </Link>
              </li>
              <li>
                <Link to="/compliance" className="text-paper hover:text-orange transition-colors">
                  {t('footer.links.compliance')}
                </Link>
              </li>
              <li>
                <Link
                  to="/responsible-play"
                  className="text-paper hover:text-orange transition-colors"
                >
                  {t('footer.links.responsiblePlay')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-paper/10 text-paper/50 flex flex-wrap items-center justify-between gap-4 border-t pt-6 font-mono text-[11px] tracking-[0.18em] uppercase">
          <span>{t('footer.bottom.copyright', { year })}</span>
          <span className="text-green inline-flex items-center gap-2">
            <span className="rounded-pill bg-green h-1.5 w-1.5" aria-hidden="true" />
            {t('footer.bottom.status')} · {new Date().toISOString().slice(11, 19)} UTC
          </span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
